import { MessageTypes } from "../types";

export function findMessageTypeFromMime(mime: string | null): number {
    if (mime == null || mime === '') return 0; // Default to text message if mime type is not provided

    if (mime.startsWith("image")) {
        return MessageTypes.IMAGE; // Image message
    } else if (mime.startsWith("audio")) {
        return MessageTypes.VOICE; // Voice message
    } else {
        return MessageTypes.FILE; // File message for all other mime types
    }
}